import testclinicPic from "../img/testclinic.png";
import vmpPic from "../img/vmp.png";
import { WINDOW_IDS } from "./windows";

const FOLDER_PIC = "https://i.ibb.co/q0YhQgR/opened-folder.png";

export const ELDEST_PROJECTS = [
  {
    name: "blogify.js",
    url: "https://blogify-mondevyat.vercel.app/",
    pic: "https://i.ibb.co/yYS4VRn/ghost.png",
  },
  {
    name: "pure CSS",
    url: "https://pure-css-pursuit-animation-mondevyat.vercel.app/",
    pic: "https://i.ibb.co/dKYjk0L/car.png",
  },
  {
    name: "yarp",
    url: "https://yarp.netlify.app",
    pic: "https://i.ibb.co/35KfY3z/favicon.png",
  },
  {
    name: "cryptify",
    url: "https://cryptify.netlify.app",
    pic: "https://i.ibb.co/cv8wr7W/669a86619be1c26f046a8dda10f8c6.png",
  },
  {
    name: "3d-portfolio",
    url: "https://zxcursed-models.netlify.app/",
    pic: "https://i.ibb.co/bHXw3Jc/3ddesign.png",
  },
  {
    name: "dallify",
    url: "https://dallify-mondevyat.netlify.app",
    pic: "https://i.ibb.co/SQ6HF2b/logo.png",
  },
];

export const PROJECTS = [
  {
    name: "itdoxy",
    url: "https://itdoxy.com/",
    pic: "https://i.ibb.co/LPmV70R/itdoxy.png",
  },
  {
    name: "testclinic",
    url: "https://testclinic.ru",
    pic: testclinicPic,
  },
  {
    name: "vmp",
    url: "https://vmp.mondevyat.com",
    pic: vmpPic,
  },
  {
    name: "eldest one",
    type: "folder",
    windowId: WINDOW_IDS.ELDEST,
    pic: FOLDER_PIC,
  },
];
